// extracted by mini-css-extract-plugin
export default {"productDescription":"c_-z","featuredDescription":"d_-z","description":"e_-z","more":"f_-z","descriptionSku":"g_-z"};